import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  actions: {

    async findItemsByContratoId(_, { id }) {
      if (!id) throw new Error('O ID do contrato é obrigatório para a busca de itens.');
      const { data } = await api.get(`cadastrocontratovenda/id/${id}`);
      return data;
    },
  },
};
